import { useAuthStore } from '@/features/auth/store/authStore.js';
import { useMyShelf } from '@/features/library/hooks/useMyShelf.js';
import { usePagesThisWeek } from '@/features/library/hooks/usePagesThisWeek.js';

const GOAL = 52;

export function GreetingCard(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const { data } = useMyShelf();
  const { data: pagesData } = usePagesThisWeek();
  const entries = data?.items ?? [];
  const total = entries.length;
  const done = entries.filter((e) => e.status === 'done').length;
  const pagesThisWeek = pagesData?.pages ?? 0;

  return (
    <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-rose-light to-cream-light p-6 shadow-md md:p-8">
      <span
        className="pointer-events-none absolute right-5 top-4 select-none text-[80px] leading-none opacity-20 md:text-[110px]"
        aria-hidden
      >
        🌿
      </span>
      <span
        className="pointer-events-none absolute -bottom-2 right-12 select-none text-3xl opacity-30 [animation:float-up_4s_ease-in-out_infinite]"
        aria-hidden
      >
        ✨
      </span>

      <p className="font-script text-xl text-terracotta-dark">
        Bonjour {user?.displayName ?? 'lectrice'} 🌿
      </p>
      <h1 className="mt-1 max-w-md font-serif text-3xl font-semibold leading-tight text-brown md:text-4xl">
        Prête pour un nouveau chapitre&nbsp;?
      </h1>

      <div className="mt-4 flex flex-wrap gap-2">
        <Stat icon="⚡" label={`${total} livre${total > 1 ? 's' : ''} au total`} />
        <Stat
          icon="📖"
          label={`${pagesThisWeek.toLocaleString('fr-FR')} page${pagesThisWeek > 1 ? 's' : ''} cette semaine`}
        />
        <Stat icon="🎯" label={`${done} / ${GOAL} livres`} />
      </div>
    </section>
  );
}

function Stat({ icon, label }: { icon: string; label: string }): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-paper/70 px-3 py-1.5 text-xs font-semibold text-brown backdrop-blur">
      <span aria-hidden>{icon}</span>
      {label}
    </span>
  );
}
